<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
    :initialFilters="filters"
  >

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="action1" slot-scope="{ item }" v-if="$can('close_period', $router.currentRoute.name) && item.canBeFinalized" >
      <FinalizePeriod
        :entry="item"
        @entry-destroyed="entryFinalized"
      />
    </template>

    <template slot="action2" slot-scope="{ item }" v-if="$can('read', 'PeriodExecutionReport')">
      <Show
        :entry="item"
      />
    </template>

    <template slot="action3" slot-scope="{ item }" v-if="$can('read', 'PeriodPlanningReport')" >
      <PlanningShow
        :entry="item"
      />
    </template>

     <template slot="action4" slot-scope="{ item }" v-if="item.status == 'finalized'" >
      <ReopenPeriod
        :entry="item"
        @entry-destroyed="entryReopened"
      />
    </template>

    <template slot="tableFooter" v-if="loggedUser && loggedUser.account && !loggedUser.account.hasSeedlingProducerBusinessActivity">
      <tr class="d-none d-md-table-row">
        <td colspan="4" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="8" class="text-left title"><strong>{{ this.periodsTotalArea | formatNumber }} ha</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Área Total:</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.periodsTotalArea | formatNumber }} ha</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import FinalizePeriod from "./finalize_period.vue";
import ReopenPeriod from "./reopen_period.vue";
import Show from "./show.vue";
import PlanningShow from "./planning_show.vue"

export default {
  data() {
    return {
      loggedUser: {},
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      periodsTotalArea: 0,
      firstLoad: true, //usado pra não deixar carregar o primeiro load do index, por causa do condicional do ramo de atividade
      // tableHeaders: [
      //   //trocar id para code depois que vier a coluna
      //   { text: "Código", align: "left", sortable: true, value: "code" },
      //   { text: "Talhão", align: "left", sortable: true, value: "field.name" },
      //   { text: "Safra", align: "left", sortable: true, value: "harvest.name" },
      //   { text: "Cultura", align: "left", sortable: true, value: "culture.name" },
      //   { text: "Área", align: "left", sortable: true, value: "area" },
      //   { text: "Início Est.", align: "left", sortable: true, value: "startPrediction" },
      //   { text: "Início", align: "left", sortable: true, value: "startDate" },
      //   { text: "Fim Est.", align: "left", sortable: true, value: "expectedEndDate" },
      //   { text: "Fim", align: "left", sortable: true, value: "endDate" },
      //   { text: "Status", align: "left", sortable: true, value: "statusText", filter_value: "status" },
      //   { text: "Ações", align: "left", sortable: false, value: "action" }
      // ],
      maskFields: [
        { field: 'area', mask: 'number_unit', unit: 'ha'},
        { field: 'startPrediction', mask: 'date'},
        { field: 'startDate', mask: 'date'},
        { field: 'expectedEndDate', mask: 'date'},
        { field: 'endDate', mask: 'date' },
        { field: 'statusText', mask: 'status_color', colorField: 'statusColor' }, 
        { field: 'seedsPlantedQuantity', mask: 'number' },
        {field: "enabled", mask: "nice_boolean"},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [{
        field: "enabled",
        fieldValues: [true],
        key: 0,
        operator: "in",
        type: "boolean"
      }], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Ciclo"
    },
    modelNamePlural: {
      type: String,
      default: "Ciclos"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    FinalizePeriod: FinalizePeriod,
    ReopenPeriod: ReopenPeriod,
    Show: Show,
    PlanningShow: PlanningShow,
  },
  created() {
    // this.loadServerEntries();
    this.getCurrentUser(user => {
      this.loggedUser = user;
      let callForLoading = this.tableHeaders;
      this.loadServerEntries();
    });
  },
  computed: {
    tableHeaders: function() {
      if (this.loggedUser && this.loggedUser.account && this.loggedUser.account.hasSeedlingProducerBusinessActivity) {
        return [
            //tabela para viveiro
            { text: "Código", align: "left", sortable: true, value: "code" },
            { text: "Talhão", align: "left", sortable: true, value: "fieldName" },
            { text: "Safra", align: "left", sortable: true, value: "harvestName" },
            { text: "Cultura", align: "left", sortable: true, value: "cultureName" },
            { text: "Variedade/Qtd. Plantada", align: "left", sortable: true, value: "varietiesText" },
            // { text: "Área", align: "left", sortable: true, value: "area" },
            // { text: "Início Est.", align: "left", sortable: true, value: "startPrediction" },
            // { text: "Qtd. Plantada", align: "left", sortable: true, value: "seedsPlantedQuantity" },
            // { text: "Unid. Plantada", align: "left", sortable: true, value: "seedsPlantedUnit" },
            { text: "Início", align: "left", sortable: true, value: "startDate" },
            { text: "Plantio", align: "left", sortable: true, value: "firstPlantingDateText" },
            { text: "Fim Est.", align: "left", sortable: true, value: "expectedEndDate" },
            { text: "Fim", align: "left", sortable: true, value: "endDate" },
            { text: "Status", align: "left", sortable: true, value: "statusText", filter_value: "status" },
            { text: "Ativo", align: "left", sortable: true, value: "enabled" },
            { text: "Ações", align: "left", sortable: false, value: "action" }
          ];
      } else {
        return [
          //tabela para todos os outros ramos que nao sao viveiro
          { text: "Código", align: "left", sortable: true, value: "code" },
          { text: "Identificador", align: "left", sortable: true, value: "identifier" },
          { text: "Talhão", align: "left", sortable: true, value: "fieldName" },
          { text: "Safra", align: "left", sortable: true, value: "harvestName" },
          { text: "Cultura", align: "left", sortable: true, value: "cultureName" },
          { text: "Área", align: "left", sortable: true, value: "area" },
          { text: "Início Est.", align: "left", sortable: true, value: "startPrediction" },
          { text: "Início", align: "left", sortable: true, value: "startDate" },
          { text: "Fim Est.", align: "left", sortable: true, value: "expectedEndDate" },
          { text: "Fim", align: "left", sortable: true, value: "endDate" },
          { text: "Status", align: "left", sortable: true, value: "statusText", filter_value: "status" },
          { text: "Ativo", align: "left", sortable: true, value: "enabled" },
          { text: "Ações", align: "left", sortable: false, value: "action" }
        ]
      }
    }
  },
  methods: {
    applyFilters: function(filtersList) { //função executada quando o usuário adicionar, editar ou remover um filtro 
      this.filters = filtersList;
      this.options.page = 1; //sempre carrega a primeira página da paginação quando há alterações de filtros
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_PERIODS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("RESPONSE do periods", response);
          //this.periods = response.data.accountContext.periodsIndex.periods;
          //console.log("All periods", this.periods);
          this.indexItems = response.data.groundContext.periodsIndex.periodViewIndexFilters; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.groundContext.periodsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.groundContext.periodsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.groundContext.periodsIndex.serverFields; // seta os campos que podem ser filtrados

          if (this.loggedUser && this.loggedUser.account && !this.loggedUser.account.hasSeedlingProducerBusinessActivity) {
            this.periodsTotalArea = 0;
            for (var period in this.indexItems) {
              this.periodsTotalArea += this.indexItems[period].area;
            }
            this.periodsTotalArea = _.round(this.periodsTotalArea, 2);
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    entryFinalized: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Ciclo finalizado com sucesso!");
    },
    entryReopened: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Ciclo reaberto com sucesso!");
    },
    optionsChange: function(opts) {
      this.options = opts;
      // console.log("options changed")
      if (!this.firstLoad) {
        this.loadServerEntries();
      }
      this.firstLoad = false;
    },
  }
};

const LOAD_ALL_PERIODS = gql `
  query($input: IndexInputObject!) {
    groundContext {
      periodsIndex(input: $input) {
        count
        typeOperators
        serverFields
        periodViewIndexFilters {
          id
          code
          name
          identifier
          enabled          
          groundName
          fieldName
          harvestName
          cultureName
          area
          status
          statusText
          statusColor
          startDate
          startPrediction
          endDate
          expectedEndDate
          seedsPlantedQuantity
          seedsPlantedUnit
          firstPlantingDateText
          varietiesText
          canBeFinalized
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>
